function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3,1.466a1.52,1.52,0,0,0,.4,1.04L7.652,7,3.405,11.494a1.531,1.531,0,0,0,0,2.075,1.33,1.33,0,0,0,1.961,0l5.227-5.532a1.522,1.522,0,0,0,0-2.072L5.366.431a1.33,1.33,0,0,0-1.961,0A1.51,1.51,0,0,0,3,1.466",
  fill: "currentColor",
  fillRule: "evenodd"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-right-1.53555680.svg";
export { SvgComponent as ReactComponent };